import { isDefined } from '@sama/js-core';
import { matches } from '@sama/micro-dash';
import { AnnotationOutput } from '../../../team-apis/otterdam/outputs/annotation-output';
import { AbstractOutputWithAnswerOptions } from '../../../team-apis/otterdam/outputs/output';
import { SensorFusionOutput } from '../../../team-apis/otterdam/outputs/sensor-fusion-output';
import { Project } from '../../../team-apis/otterdam/project';

/** @deprecated used for old projects without objects */
export function getColorOutput(
  project: Project,
  output: AnnotationOutput | SensorFusionOutput,
) {
  const colorId = output.meta.nested_output_color_id;
  if (isDefined(colorId)) {
    return project.outputs.find(
      matches({ id: colorId }),
    ) as AbstractOutputWithAnswerOptions;
  }
  return undefined;
}
